import MediumTypography from '../../components/formlib/MediumTypography';
import { ReactComponent as DownArrow } from '../../assets/images/downarrowcolored.svg';
import { ReactComponent as UpArrow } from '../../assets/images/uparrowcolored.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/infoIcon.svg';
import { FC, useContext, useEffect, useRef, useState } from 'react';
import InformationModal from './InformationModal';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableContainer,
} from '@mui/material';
import Textinput from '../../components/formlib/Textinput';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import { ReactComponent as AddNew } from '../../assets/images/Plus.svg';
import ServiceDeliveryPlanData from './IFSP/ServiceDeliveryPlan.json';
import { ReactComponent as Delete } from '../../assets/images/deleteAlertIcon.svg';

import { ReactComponent as HideIcon } from '../../assets/images/hideIcon.svg';
import { ReactComponent as PrinterIcon } from '../../assets/images/printerIcon.svg';
import { ReactComponent as FilledAddIcon } from '../../assets/images/filledAddIcon.svg';
import { HeadCell, TableHeader } from '../../components/formlib/TableHeader';
import EIServiceTableRow from './EIServiceTableRow';
import dayjs, { Dayjs } from 'dayjs';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import IfspContext from './ifspContextApi/IfspContex';
import {
  datePickerMinDateMaxDateValidate,
  formatStringDateInDecimals,
  formatTimeDurationInDecimals,
} from '../../utils/dateUtil';
import DurationPicker from '../../components/formlib/DurationPicker';
import { LookUpContext } from '../../context/LookUpContextProvider';
import { OptionType, Order } from '../../utils/type';
import _ from 'lodash';
import CommentTextbox from '../../components/formlib/CommentTextbox';

export interface TableData {
  eiService: string;
  providedBy: string;
  locationOfService: string;
  freqperlen: string;
  startDate: string;
  intensity: string;
  duration: string;
  endDate: string;
  reason: string;
  actions: string;
}
export type ServiceDeliveryPlanPropsData = {
  servicePlanId: string;
  eiService: string;
  providedBy: string;
  locationOfService: string;
  frequency: string;
  length: string;
  duration: string;
  period: string;
  intensity: string;
  startDate: string | null | Dayjs;
  endDate: string | null | Dayjs;
  reasonIfLate: string;
  isRecordSubmitted: boolean;
  tbrServicePlanId: number;
  tbrUpdateRequired: boolean;
};

export type ServiceDeliveryPlanType = {
  earlyInterventionService: ServiceDeliveryPlanPropsData[];
  notes: string;
  justification: string;
  otherNeededService: string;
  stepsToTake: string;
};
export const headCells: HeadCell<TableData>[] = [
  {
    id: 'eiService',
    labelId: 'EI Service/Method',
    defaultLabelId: 'EI Service/Method',
    numeric: false,
    requiredSorting: true,
  },
  {
    id: 'providedBy',
    labelId: 'Provided by (Discipline Responsibile)',
    defaultLabelId: 'Provided by (Discipline Responsibile)',
    numeric: false,
    requiredSorting: true,
  },
  {
    id: 'locationOfService',
    labelId: 'Location of Service',
    defaultLabelId: 'Location of Service',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'freqperlen',
    labelId: 'IFSP.FreqPerLen',
    defaultLabelId: 'Freq, Per, Len',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'intensity',
    labelId: 'Intensity - Individual/Group',
    defaultLabelId: 'Intensity - Individual/Group',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'duration',
    labelId: 'Duration of Service',
    defaultLabelId: 'Duration of Service',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'startDate',
    labelId: 'Start Date',
    defaultLabelId: 'Start Date',
    numeric: false,
    requiredSorting: true,
  },
  {
    id: 'endDate',
    labelId: 'End Date',
    defaultLabelId: 'End Date',
    numeric: false,
    requiredSorting: true,
  },
  {
    id: 'reason',
    labelId: 'Reason',
    defaultLabelId: 'Reason',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'actions',
    labelId: 'Actions',
    defaultLabelId: 'Actions',
    numeric: false,
    requiredSorting: false,
  },
];

interface ServiceDeliveryPlanProps {
  info: boolean;
  open: boolean;
  canEditAfterLock: boolean;
  canDeleteAfterLock: boolean;
  isIfspScreenLocked: boolean;
  isSavedClicked: boolean;
  onClose: (open: boolean) => void;
  closeInfo: (info: boolean) => void;
  onOpen: (open: boolean) => void;
  openInfo: (info: boolean) => void;
  hasEditPermission: boolean;
}

const initialValues: ServiceDeliveryPlanPropsData = {
  servicePlanId: '',
  eiService: '',
  frequency: '',
  length: '',
  intensity: '',
  locationOfService: '',
  period: '',
  providedBy: '',
  startDate: null,
  endDate: null,
  duration: '',
  reasonIfLate: '',
  isRecordSubmitted: false,
  tbrServicePlanId: 0,
  tbrUpdateRequired: true,
};

const TextAreaStyle: React.CSSProperties = {
  minWidth: '840px',
  width: '840px',
};

const EXCLUDED_CODES = [
  'CHILDGROUPCOMMUNITY',
  'CHILDGROUPEIONLY',
  'PARENTGROUP',
  'TRANSPORTATION',
];

const validationSchema = yup.object().shape({
  eiService: yup.string().required('IFSP.EIServiceisrequired'),
  frequency: yup
    .string()
    .required('IFSP.Frequencyisrequired')
    .matches(/^[1-9]$|^10$/, 'IFSP.FrequencyisGreaterThanZeroAndLessThanTen'),
  length: yup.string().required('IFSP.Lengthisrequired'),
  intensity: yup.string().required('IFSP.Intensityisrequired'),
  period: yup.string().required('IFSP.Periodisrequired'),
  locationOfService: yup.string().required('IFSP.LocationofServiceisrequired'),
  providedBy: yup.string().when('eiService', {
    is: (val: string) => !EXCLUDED_CODES.includes(val),
    then: (schema) => schema.required('IFSP.Providedbyisrequired'),
    otherwise: (schema) => schema.notRequired(),
  }),
  startDate: yup
    .date()
    .nullable()
    .typeError('Date is required')
    .required('IFSP.StartDateisrequired'),
  endDate: yup.date().nullable().typeError('Date is required'),
  duration: yup.string().required('IFSP.DurationofServiceisrequired'),
});

const ServiceDeliveryPlan: FC<ServiceDeliveryPlanProps> = ({
  info,
  open,
  isIfspScreenLocked,
  isSavedClicked,
  canEditAfterLock,
  canDeleteAfterLock,
  onOpen,
  openInfo,
  onClose,
  closeInfo,
  hasEditPermission,
}) => {
  const { ifsp, updateIfspContext, initialIfsp, updateInitialIfspContext } =
    useContext(IfspContext);
  const [sDPData, setSDPData] =
    useState<ServiceDeliveryPlanPropsData>(initialValues);
  const [sdpMainData, setSdpMainData] = useState<ServiceDeliveryPlanType[]>(
    ifsp.ifspTeam.forms.serviceDeliveryPlan,
  );

  const [showSubSection, setShowSubSection] = useState<boolean>(true);
  const [openIndex, setOpenIndex] = useState<number>(0);
  const [openedSubSectionIndex, setOpenedSubSectionIndex] = useState<number>(0);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editIndex, setEditIndex] = useState<number>(0);

  const [eiService, setEiService] = useState<OptionType[]>([]);
  const [extractedEiService, setExtractedEiService] = useState<OptionType[]>(
    [],
  );
  const [eiServiceAutism, setEiServiceAutism] = useState<OptionType[]>([]);
  const [locationOfService, setLocationOfService] = useState<OptionType[]>([]);
  const [period, setPeriod] = useState<OptionType[]>([]);
  const [intensity, setIntensity] = useState<OptionType[]>([]);
  const [providedBy, setProvidedBy] = useState<OptionType[]>([]);

  const [providedByAutism, setProvidedByAutism] = useState<OptionType[]>([]);

  const [lookUpReasons, setLookUpReasons] = useState<OptionType[]>([]);
  const [fliteredLookUpReasons, setFliteredLookUpReasons] = useState<
    OptionType[]
  >([]);
  const [order, setOrder] = useState<Order>('asc');
  const [orderBy, setOrderBy] = useState<keyof TableData | ''>('');
  const { lookups } = useContext(LookUpContext);

  const isUpdateAction = isEdit || (canEditAfterLock && isIfspScreenLocked);

  const servicePlanLabelId = isUpdateAction
    ? 'IFSP.UpdateServiceToPlan'
    : 'IFSP.SaveServiceToPlan';

  const servicePlanDefaultLabel = isUpdateAction
    ? 'Update Service to Plan'
    : 'Save Service to Plan';

  const validateDate = (values: ServiceDeliveryPlanPropsData) => {
    const errors: Partial<ServiceDeliveryPlanPropsData> = {};

    if (values.startDate) {
      if (dayjs(values.startDate).isBefore(ifsp.ifspMeetingDate)) {
        errors.startDate = 'IFSP.StartDateCantBeGreaterThanIfspMeetingDate';
      }
      if (
        ifsp.referralContactDate &&
        dayjs(values.startDate).isBefore(dayjs(ifsp.referralContactDate))
      ) {
        errors.startDate = 'IFSP.StartDateCantBeGreaterThanReferralContactDate';
      }
    }

    if (values.startDate && values.endDate) {
      const startDate = dayjs(values.startDate, 'MM/DD/YYYY');
      const endDate = dayjs(values.endDate, 'MM/DD/YYYY');

      if (startDate.isAfter(endDate)) {
        errors.endDate = 'BlockTime.endDateValidationError';
      }
    }

    if (datePickerMinDateMaxDateValidate(values.startDate)) {
      errors.startDate = 'datePickerMinDateMaxDateValidate';
    }
    if (datePickerMinDateMaxDateValidate(values.endDate)) {
      errors.endDate = 'datePickerMinDateMaxDateValidate';
    }
    return errors;
  };

  useEffect(() => {
    formikRef.current?.setTouched({});
  }, [open]);

  useEffect(() => {
    if (lookups === null) {
      return;
    }

    setLocationOfService(() => {
      return lookups.locationOfService?.map((l) => {
        return {
          label: l.description,
          id: l.code,
        };
      });
    });

    setPeriod(() => {
      return lookups.period?.map((p) => {
        return {
          label: p.description,
          id: p.code,
        };
      });
    });

    setProvidedBy(() => {
      return lookups.ifspDiscipline?.map((p) => {
        return {
          label: p.description,
          id: p.code,
        };
      });
    });

    setIntensity(() => {
      return lookups.intensity?.map((i) => {
        return {
          label: i.description,
          id: i.code,
        };
      });
    });
    setLookUpReasons(() => {
      return lookups.ifspServicePlanReason?.map((e) => {
        return {
          label: e.description,
          id: e.code,
        };
      });
    });

    setFliteredLookUpReasons(() => {
      return lookups.ifspServicePlanReason?.map((e) => {
        return {
          label: e.description,
          id: e.code,
        };
      });
    });
  }, [lookups]);

  useEffect(() => {
    if (lookups === null) {
      return;
    }

    const earlyIntervention =
      sdpMainData?.[openIndex]?.earlyInterventionService?.[editIndex];

    setProvidedByAutism(() => {
      return lookups.ifspDiscipline
        .filter((e) => {
          // Always include active ones
          if (e.active && e.isAutism) return true;

          // If editing, also include the inactive one being edited
          if (
            isEdit &&
            e.code ===
              sdpMainData[openIndex].earlyInterventionService[editIndex]
                .providedBy
          )
            return true;

          return false;
        })
        .map((data) => {
          return {
            label: data.description,
            id: data.code,
          };
        });
    });

    const actualEiService = isEdit
      ? lookups.eiService?.filter((e) => {
          return e.code === earlyIntervention?.eiService || !e.isAutism;
        })
      : lookups.eiService?.filter((e) => !e.isAutism);

    setExtractedEiService(() => {
      return (
        actualEiService
          ?.filter((e) => {
            // Always include active ones
            if (e.active) return true;

            // If editing, also include the inactive one being edited
            if (
              isEdit &&
              e.code ===
                sdpMainData[openIndex].earlyInterventionService[editIndex]
                  .eiService
            )
              return true;

            return false;
          })
          .map((e) => ({
            label: e.description,
            id: e.code,
          })) ?? []
      );
    });

    setEiService(() => {
      return lookups.eiService?.map((e) => ({
        label: e.description,
        id: e.code,
      }));
    });

    setEiServiceAutism(() => {
      return lookups.eiService
        .filter((e) => {
          // Always include active ones
          if (e.active && e.isAutism) return true;

          // If editing, also include the inactive one being edited
          if (
            isEdit &&
            e.code ===
              sdpMainData[openIndex].earlyInterventionService[editIndex]
                .eiService
          )
            return true;

          return false;
        })
        .map((data) => {
          return {
            label: data.description,
            id: data.code,
          };
        });
    });

    setFliteredLookUpReasons(() => {
      return lookups.ifspServicePlanReason
        ?.filter((e) => {
          if (e.active) return true;
          if (
            isEdit &&
            e.code ===
              sdpMainData[openIndex].earlyInterventionService[editIndex]
                .reasonIfLate
          )
            return true;
          return false;
        })
        .map((e) => {
          return {
            label: e.description,
            id: e.code,
          };
        });
    });
  }, [lookups, isEdit, editIndex, openedSubSectionIndex, openIndex]);

  useEffect(() => {
    const updatedData = [...sdpMainData];

    const services = [...updatedData[openIndex].earlyInterventionService];

    if (orderBy === 'eiService') {
      services.sort((a, b) =>
        order === 'asc'
          ? a.eiService.localeCompare(b.eiService)
          : b.eiService.localeCompare(a.eiService),
      );
    } else if (orderBy === 'providedBy') {
      services.sort((a, b) =>
        order === 'asc'
          ? a.providedBy.localeCompare(b.providedBy)
          : b.providedBy.localeCompare(a.providedBy),
      );
    } else if (orderBy === 'startDate') {
      services.sort((a, b) => {
        const aDate = a.startDate ? dayjs(a.startDate).toISOString() : '';
        const bDate = b.startDate ? dayjs(b.startDate).toISOString() : '';

        return order === 'asc'
          ? aDate.localeCompare(bDate)
          : bDate.localeCompare(aDate);
      });
    } else if (orderBy === 'endDate') {
      services.sort((a, b) => {
        const aDate = a.endDate ? dayjs(a.endDate).toISOString() : '';
        const bDate = b.endDate ? dayjs(b.endDate).toISOString() : '';

        return order === 'asc'
          ? aDate.localeCompare(bDate)
          : bDate.localeCompare(aDate);
      });
    }

    updatedData[openIndex] = {
      ...updatedData[openIndex],
      earlyInterventionService: services,
    };

    setSdpMainData(updatedData);

    //update initialIfsp only for the openIndex
    const initialSdpData = initialIfsp.ifspTeam.forms.serviceDeliveryPlan;
    const updatedInitialSdpData = initialSdpData.map((sdp, index) => {
      if (index === openIndex) {
        const initialServices = [...sdp.earlyInterventionService];

        // Apply same sorting on initialServices (separate from currentData)
        if (orderBy === 'eiService') {
          initialServices.sort((a, b) =>
            order === 'asc'
              ? a.eiService.localeCompare(b.eiService)
              : b.eiService.localeCompare(a.eiService),
          );
        } else if (orderBy === 'providedBy') {
          initialServices.sort((a, b) =>
            order === 'asc'
              ? a.providedBy.localeCompare(b.providedBy)
              : b.providedBy.localeCompare(a.providedBy),
          );
        } else if (orderBy === 'startDate') {
          initialServices.sort((a, b) => {
            const aDate = a.startDate ? dayjs(a.startDate).toISOString() : '';
            const bDate = b.startDate ? dayjs(b.startDate).toISOString() : '';

            return order === 'asc'
              ? aDate.localeCompare(bDate)
              : bDate.localeCompare(aDate);
          });
        } else if (orderBy === 'endDate') {
          initialServices.sort((a, b) => {
            const aDate = a.endDate ? dayjs(a.endDate).toISOString() : '';
            const bDate = b.endDate ? dayjs(b.endDate).toISOString() : '';

            return order === 'asc'
              ? aDate.localeCompare(bDate)
              : bDate.localeCompare(aDate);
          });
        }

        return {
          ...sdp,
          earlyInterventionService: initialServices,
        };
      } else {
        return sdp; // untouched for other indices
      }
    });

    updateInitialIfspContext({
      ...initialIfsp,
      ifspTeam: {
        ...initialIfsp.ifspTeam,
        forms: {
          ...initialIfsp.ifspTeam.forms,
          serviceDeliveryPlan: updatedInitialSdpData,
        },
      },
    });
  }, [order, orderBy]);

  const formikRef = useRef<FormikProps<ServiceDeliveryPlanPropsData>>(null);

  const sortServices = (
    services: ServiceDeliveryPlanPropsData[],
    orderB: string,
    orde: 'asc' | 'desc',
  ) => {
    return [...services].sort((a, b) => {
      if (orderB === 'eiService') {
        return orde === 'asc'
          ? a.eiService.localeCompare(b.eiService)
          : b.eiService.localeCompare(a.eiService);
      } else if (orderB === 'providedBy') {
        return orde === 'asc'
          ? a.providedBy.localeCompare(b.providedBy)
          : b.providedBy.localeCompare(a.providedBy);
      } else if (orderB === 'startDate') {
        const aDate = a.startDate ? dayjs(a.startDate).toISOString() : '';
        const bDate = b.startDate ? dayjs(b.startDate).toISOString() : '';
        return orde === 'asc'
          ? aDate.localeCompare(bDate)
          : bDate.localeCompare(aDate);
      } else if (orderB === 'endDate') {
        const aDate = a.endDate ? dayjs(a.endDate).toISOString() : '';
        const bDate = b.endDate ? dayjs(b.endDate).toISOString() : '';
        return orde === 'asc'
          ? aDate.localeCompare(bDate)
          : bDate.localeCompare(aDate);
      }
      return 0;
    });
  };

  const handleAddServiceDeliveryPlan = (
    subSectionIndex: number,
    values: ServiceDeliveryPlanPropsData,
  ) => {
    if (isEdit) {
      const updatedSdpData = sdpMainData[
        subSectionIndex
      ].earlyInterventionService.map(
        (earlyInterventionService, earlyInterventionServiceIndex) =>
          earlyInterventionServiceIndex === editIndex
            ? {
                ...earlyInterventionService,
                eiService: values.eiService,
                providedBy: values.providedBy,
                length: values.length,
                period: values.period,
                locationOfService: values.locationOfService,
                frequency: values.frequency,
                duration: values.duration,
                intensity: values.intensity,
                startDate: values.startDate,
                endDate: values.endDate,
                reasonIfLate: values.reasonIfLate,
                tbrServicePlanId: values.tbrServicePlanId,
                tbrUpdateRequired: values.tbrUpdateRequired
                  ? true
                  : !_.isEqual(
                      initialIfsp.ifspTeam.forms.serviceDeliveryPlan[
                        subSectionIndex
                      ].earlyInterventionService[editIndex],
                      values,
                    ),
              }
            : earlyInterventionService,
      );

      setSdpMainData((prevData) => {
        const tempData = [...prevData];
        tempData[subSectionIndex].earlyInterventionService = sortServices(
          updatedSdpData,
          orderBy,
          order,
        );
        return tempData;
      });

      setIsEdit(false);
    } else {
      setSdpMainData((prevData) => {
        const tempData = [...prevData];
        const newService = {
          servicePlanId: values.servicePlanId,
          eiService: values.eiService,
          providedBy: values.providedBy,
          locationOfService: values.locationOfService,
          length: values.length,
          frequency: values.frequency,
          duration: values.duration,
          period: values.period,
          intensity: values.intensity,
          startDate: values.startDate,
          endDate: values.endDate,
          reasonIfLate: values.reasonIfLate,
          isRecordSubmitted: values.isRecordSubmitted,
          tbrServicePlanId: values.tbrServicePlanId,
          tbrUpdateRequired: true,
        };

        tempData[subSectionIndex].earlyInterventionService = sortServices(
          [...tempData[subSectionIndex].earlyInterventionService, newService],
          orderBy,
          order,
        );

        return tempData;
      });

      resetSDPData();
    }
  };

  const resetSDPData = () => {
    setSDPData(initialValues);
  };

  const addSubSection = () => {
    formikRef.current?.setTouched({});
    formikRef.current?.resetForm();
    setOpenIndex(1);
    setSdpMainData([
      ...sdpMainData,
      {
        earlyInterventionService: [],
        notes: '',
        justification: '',
        otherNeededService: '',
        stepsToTake: '',
      },
    ]);
  };

  const onEditRow = (subSectionIndex: number, index: number) => {
    setEditIndex(index);
    const editableData =
      sdpMainData[subSectionIndex].earlyInterventionService[index];
    formikRef.current?.setValues({
      servicePlanId: editableData.servicePlanId,
      eiService: editableData.eiService,
      providedBy: editableData.providedBy,
      locationOfService: editableData.locationOfService,
      length: editableData.length ?? '0.00',
      frequency: editableData.frequency,
      period: editableData.period,
      duration: editableData.duration,
      intensity: editableData.intensity,
      startDate: editableData.startDate,
      endDate: editableData.endDate,
      reasonIfLate: editableData.reasonIfLate,
      isRecordSubmitted: editableData.isRecordSubmitted,
      tbrServicePlanId: editableData.tbrServicePlanId,
      tbrUpdateRequired: editableData.tbrUpdateRequired,
    });
    setSDPData({
      servicePlanId: editableData.servicePlanId,
      eiService: editableData.eiService,
      providedBy: editableData.providedBy,
      locationOfService: editableData.locationOfService,
      length: editableData.length,
      frequency: editableData.frequency,
      duration: editableData.duration,
      period: editableData.period,
      intensity: editableData.intensity,
      startDate: editableData.startDate,
      endDate: editableData.endDate,
      reasonIfLate: editableData.reasonIfLate,
      isRecordSubmitted: editableData.isRecordSubmitted,
      tbrServicePlanId: editableData.tbrServicePlanId,
      tbrUpdateRequired: editableData.tbrUpdateRequired,
    });
    setIsEdit(true);
  };

  const onDeleteRow = (subSectionIndex: number, index: number) => {
    updateIfspContext({
      ...ifsp,
      isEIServiceOrOutcomesInfoDeleted:
        !!sdpMainData[subSectionIndex].earlyInterventionService[index]
          .servicePlanId,
    });
    setSdpMainData((prevData) => {
      const tempData = [...prevData];
      tempData[subSectionIndex].earlyInterventionService.splice(index, 1);
      return tempData;
    });
  };

  const deleteSubSection = (index: number) => {
    const newSdpData = sdpMainData.filter((__, i) => i !== index);
    setSdpMainData(newSdpData);
    if (openIndex === index) {
      setShowSubSection(false);
    } else if (openIndex && openIndex > index) {
      setOpenIndex(openIndex - 1);
    }
  };

  useEffect(() => {
    setSdpMainData(ifsp.ifspTeam.forms.serviceDeliveryPlan);
  }, [ifsp.ifspTeam.forms.serviceDeliveryPlan]);

  useEffect(() => {
    updateIfspContext({
      ...ifsp,
      ifspTeam: {
        ...ifsp.ifspTeam,
        forms: {
          ...ifsp.ifspTeam.forms,
          serviceDeliveryPlan: sdpMainData,
        },
      },
    });
  }, [sdpMainData]);

  useEffect(() => {
    formikRef.current?.resetForm();
    setIsEdit(false);
  }, [isSavedClicked]);

  const handleRequestSort = (
    _event: React.MouseEvent<unknown>,
    property: keyof TableData,
  ) => {
    setOrder(order === 'asc' ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <Box component="main">
      <Box component="section">
        <Box component="div">
          <Formik
            initialValues={{
              servicePlanId: sDPData.servicePlanId,
              eiService: sDPData.eiService,
              providedBy: sDPData.providedBy,
              locationOfService: sDPData.locationOfService,
              length: sDPData.length,
              period: sDPData.period,
              frequency: sDPData.frequency,
              duration: sDPData.duration,
              intensity: sDPData.intensity,
              startDate: sDPData.startDate,
              endDate: sDPData.endDate,
              reasonIfLate: sDPData.reasonIfLate,
              isRecordSubmitted: sDPData.isRecordSubmitted,
              tbrServicePlanId: sDPData.tbrServicePlanId,
              tbrUpdateRequired: sDPData.tbrUpdateRequired,
            }}
            innerRef={formikRef}
            validationSchema={validationSchema}
            validate={validateDate}
            onSubmit={(values, { resetForm }) => {
              const selectedService = eiService.find(
                (item) => item.id === values.eiService,
              );
              const selectedProvider = providedBy.find(
                (item) => item.id === values.providedBy,
              );
              const selectedLocationService = locationOfService.find(
                (item) => item.id === values.locationOfService,
              );
              const selectedIntensity = intensity.find(
                (item) => item.id === values.intensity,
              );
              const selectedPeriod = period.find(
                (item) => item.id === values.period,
              );

              handleAddServiceDeliveryPlan(openedSubSectionIndex, {
                ...values,
                eiService: selectedService?.id || '',
                providedBy: selectedProvider?.id || '',
                period: selectedPeriod?.id || '',
                locationOfService: selectedLocationService?.id || '',
                intensity: selectedIntensity?.id || '',
              });
              resetForm();
            }}
          >
            {({ values, setFieldValue, errors, touched, handleSubmit }) => (
              <Box component="div">
                {info && (
                  <InformationModal
                    open={info}
                    titleLabel="IFSP.Information"
                    titleDefaultLabel="Information"
                    buttonLabel="IFSP.InfoOkButton"
                    buttonDefaultLabel="Ok"
                    onClose={() => {
                      closeInfo(info);
                    }}
                    info={ServiceDeliveryPlanData.info}
                  />
                )}
                <Box
                  component="div"
                  className="p-lg borderRadius4"
                  sx={{
                    border: '1px solid #00C6B8',
                    backgroundColor: '#ECF9F8',
                  }}
                >
                  <Box
                    component="div"
                    className="flex__justify__space-between"
                    sx={{
                      paddingBottom:
                        open && sdpMainData.length > 0 ? '24px' : 0,
                      borderBottom:
                        open && sdpMainData.length > 0
                          ? '1px solid #00C6B8'
                          : 'none',
                    }}
                  >
                    <Box className="flex__ ">
                      <MediumTypography
                        labelid="IFSP.session6"
                        defaultlabel="Service Delivery Plan"
                        fontSize="18px"
                        fontweight={600}
                        textColor="#2A4241"
                        sxProps={{
                          marginBottom:
                            open && sdpMainData.length < 1 ? '24px' : '0px',
                        }}
                      />
                      {open && (
                        <InfoIcon
                          onClick={() => {
                            openInfo(info);
                          }}
                          className="mt-xs ml-sm cursorPointer"
                        />
                      )}
                    </Box>
                    {!open ? (
                      <DownArrow
                        className="cursorPointer"
                        style={{ color: '#008C82' }}
                        onClick={() => {
                          onOpen(open);
                        }}
                      />
                    ) : (
                      <UpArrow
                        className="cursorPointer"
                        onClick={() => {
                          onClose(open);
                        }}
                      />
                    )}
                  </Box>
                  {open && sDPData && (
                    <Box component="div">
                      {sdpMainData.map((__, subSectionIndex) => (
                        <Box
                          component="div"
                          key={`serviceDeliveryPlanSubSection${
                            subSectionIndex + 1
                          }`}
                        >
                          <Box
                            component="div"
                            className="flex__justify__space-between mt-lg mb-lg"
                            sx={{
                              paddingBottom:
                                showSubSection && openIndex === subSectionIndex
                                  ? '0px'
                                  : '24px',
                              borderBottom:
                                showSubSection && openIndex === subSectionIndex
                                  ? 'none'
                                  : '1px solid #00C6B8',
                            }}
                          >
                            <Box
                              component="div"
                              className="flex__ align__items__center"
                            >
                              {showSubSection &&
                              openIndex === subSectionIndex ? (
                                <HideIcon
                                  onClick={() => {
                                    setShowSubSection(false);
                                    setIsEdit(false);
                                    setOpenIndex(subSectionIndex);
                                  }}
                                  className="cursorPointer"
                                />
                              ) : (
                                <FilledAddIcon
                                  onClick={() => {
                                    formikRef.current?.resetForm();
                                    setShowSubSection(true);
                                    setIsEdit(false);
                                    setOpenIndex(subSectionIndex);
                                  }}
                                  className="cursorPointer"
                                />
                              )}
                              {subSectionIndex === 0 ? (
                                <MediumTypography
                                  labelid="IFSP.addService"
                                  defaultlabel="Add Services"
                                  textColor="#2A4241"
                                  fontweight={600}
                                  fontSize="16px"
                                  className="mr-sm ml-sm"
                                />
                              ) : (
                                <MediumTypography
                                  labelid="IFSP.earlyInterventionServicesForSSPAutism"
                                  defaultlabel="Early Intervention Services for SSP Autism"
                                  textColor="#2A4241"
                                  fontweight={600}
                                  fontSize="16px"
                                  className="mr-sm ml-sm"
                                />
                              )}
                            </Box>
                            <Box
                              component="div"
                              className="flex__ justifyContent-FlexEnd"
                            >
                              <Box
                                component="div"
                                className="cursorPointer flex__ align__items__center visibility__hidden"
                              >
                                <PrinterIcon />
                                <MediumTypography
                                  labelid="IFSP.print"
                                  defaultlabel="Print"
                                  textColor="#2A4241"
                                  fontweight={700}
                                  fontSize="16px"
                                  className="ml-xs"
                                />
                              </Box>
                              {subSectionIndex !== 0 &&
                                !isIfspScreenLocked &&
                                sdpMainData[
                                  subSectionIndex
                                ].earlyInterventionService.every(
                                  (i) => i.isRecordSubmitted === false,
                                ) &&
                                (sdpMainData[
                                  subSectionIndex
                                ].earlyInterventionService.some(
                                  (i) => i.tbrServicePlanId < 1,
                                ) ||
                                  sdpMainData[subSectionIndex]
                                    .earlyInterventionService.length === 0) && (
                                  <Box
                                    component="div"
                                    className="cursorPointer flex__ align__items__center ml-lg"
                                    onClick={() => {
                                      if (!isIfspScreenLocked) {
                                        deleteSubSection(subSectionIndex);
                                      }
                                    }}
                                  >
                                    <Delete />
                                    <MediumTypography
                                      labelid="IFSP.Delete"
                                      defaultlabel="Delete"
                                      textColor="#EB4C60"
                                      fontweight={700}
                                      fontSize="16px"
                                      className="ml-xs"
                                    />
                                  </Box>
                                )}
                            </Box>
                          </Box>
                          {showSubSection && openIndex === subSectionIndex && (
                            <Box component="div">
                              <Grid
                                container
                                rowSpacing={'24px'}
                                sx={{
                                  pointerEvents: hasEditPermission
                                    ? 'auto'
                                    : 'none',
                                  opacity: hasEditPermission ? 'unset' : '0.8',
                                }}
                              >
                                <Grid item xs={5}>
                                  <DropdownComponent
                                    disabled={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    names={
                                      subSectionIndex === 0
                                        ? extractedEiService
                                        : eiServiceAutism
                                    }
                                    defaultlabelid="EI Service/Method"
                                    labelid="IFSP.EIService/Method"
                                    value={values.eiService}
                                    handleChange={(value: string) => {
                                      setFieldValue('eiService', value);
                                    }}
                                    Required
                                  />
                                  {errors.eiService && touched.eiService && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.eiService}
                                      defaultlabel="EI Service/Method is Required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={0.5}></Grid>
                                <Grid item xs={5}>
                                  <DropdownComponent
                                    disabled={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    names={
                                      subSectionIndex === 0
                                        ? providedBy
                                        : providedByAutism
                                    }
                                    value={values.providedBy}
                                    defaultlabelid="Provided by (Discipline Responsibile)"
                                    labelid="IFSP.provided"
                                    handleChange={(value: string) => {
                                      setFieldValue('providedBy', value);
                                    }}
                                    Required
                                  />
                                  {errors.providedBy && touched.providedBy && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.providedBy}
                                      defaultlabel="Provided by is Required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={5}>
                                  <DropdownComponent
                                    disabled={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    names={locationOfService}
                                    value={values.locationOfService}
                                    defaultlabelid="Location of Service"
                                    labelid="ifsp.locationOfService"
                                    handleChange={(value: string) => {
                                      setFieldValue('locationOfService', value);
                                    }}
                                    Required
                                  />
                                  {errors.locationOfService &&
                                    touched.locationOfService && (
                                      <MediumTypography
                                        className="errorText-md"
                                        labelid={errors.locationOfService}
                                        defaultlabel="Location of Service is Required"
                                      />
                                    )}
                                </Grid>
                                <Grid item xs={0.5}></Grid>
                                <Grid item xs={5}>
                                  <Textinput
                                    disabled={
                                      (isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                      !canEditAfterLock
                                    }
                                    className="bg__white"
                                    name="frequencyAndLength"
                                    Value={values.frequency}
                                    labelid="IFSP.frequency"
                                    defaultlabelid="Frequency (In Numbers)"
                                    inputProps={{
                                      className: 'translate',
                                      maxLength: 500,
                                    }}
                                    Required
                                    handlechange={(value: string) => {
                                      const filteredValue = value.replace(
                                        /\D/g,
                                        '',
                                      );
                                      setFieldValue('frequency', filteredValue);
                                    }}
                                  />
                                  {errors.frequency && touched.frequency && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.frequency}
                                      defaultlabel="Frequency is Required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={5}>
                                  <DropdownComponent
                                    disabled={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    names={period}
                                    value={values.period}
                                    defaultlabelid="Period"
                                    labelid="IFSP.period"
                                    handleChange={(value: string) => {
                                      setFieldValue('period', value);
                                    }}
                                    Required
                                  />
                                  {errors.period && touched.period && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.period}
                                      defaultlabel="Period is Required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={0.5}></Grid>
                                <Grid item xs={5}>
                                  <DurationPicker
                                    uniqueId={`lengthduration-${subSectionIndex}`}
                                    placeholderRequired={values.length === ''}
                                    disabled={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    labelId={'IFSP.length'}
                                    interval={25}
                                    backgroundColor="#fff"
                                    defaultLabel={'Length (In Hours)'}
                                    maxDuration={{
                                      hour: 24,
                                      minutes: 0,
                                    }}
                                    required
                                    duration={formatStringDateInDecimals(
                                      values.length,
                                    )}
                                    setDuration={(duration) => {
                                      setFieldValue(
                                        `length`,
                                        formatTimeDurationInDecimals(
                                          duration,
                                          '.',
                                        ),
                                      );
                                    }}
                                  />
                                  {errors.length && touched.length && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.length}
                                      defaultlabel="Length is Required"
                                    />
                                  )}
                                </Grid>

                                <Grid item xs={5}>
                                  <DropdownComponent
                                    disabled={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    names={intensity}
                                    value={values.intensity}
                                    defaultlabelid="Intensity - Individual/Group"
                                    labelid="IFSP.intensity-IndividualGroup"
                                    handleChange={(value: string) => {
                                      setFieldValue('intensity', value);
                                    }}
                                    Required
                                  />
                                  {errors.intensity && touched.intensity && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.intensity}
                                      defaultlabel="Intensity is Required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={0.5}></Grid>
                                <Grid item xs={5}>
                                  <Textinput
                                    disabled={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    className="bg__white"
                                    name="durationofService"
                                    Value={values.duration}
                                    labelid="IFSP.durationOfService"
                                    defaultlabelid="Duration of Service (Ex: 1 week, 2 months)"
                                    inputProps={{
                                      className: 'translate',
                                      maxLength: 500,
                                    }}
                                    handlechange={(value: string) => {
                                      setFieldValue('duration', value);
                                    }}
                                    Required
                                  />
                                  {errors.duration && touched.duration && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.duration}
                                      defaultlabel="Duration of Service is Required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={5}>
                                  <DatePickerComponent
                                    disabledDate={
                                      ((isIfspScreenLocked ||
                                        values.tbrServicePlanId > 0 ||
                                        values.isRecordSubmitted) &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    className="bg__white"
                                    labelid="IFSP.startDate"
                                    disableFuture={false}
                                    defaultlabelid="Start Date"
                                    value={
                                      values.startDate
                                        ? dayjs(values.startDate)
                                        : null
                                    }
                                    required={true}
                                    handlechange={(dateValue: Dayjs | null) => {
                                      setFieldValue('endDate', '');
                                      const formattedDate =
                                        dayjs(dateValue).format('MM/DD/YYYY');
                                      if (dateValue === null) {
                                        setFieldValue('startDate', null);
                                      } else {
                                        setFieldValue(
                                          'startDate',
                                          formattedDate,
                                        );
                                      }
                                    }}
                                  />
                                  {errors.startDate && touched.startDate && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.startDate}
                                      defaultlabel="Start Date is Required"
                                    />
                                  )}
                                  {values.startDate && (
                                    <MediumTypography
                                      fontweight={600}
                                      fontStyle="italic"
                                      className="mt-xs"
                                      labelid={
                                        'IFSP.serviceDeliveryMustBeDeliveredWithin30Days'
                                      }
                                      defaultlabel="*This service must be delivered within 30 days of the Start Date; otherwise, the Reason for Late is required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={0.5}></Grid>

                                <Grid item xs={5}>
                                  <DatePickerComponent
                                    disabledDate={
                                      ((isIfspScreenLocked ||
                                        values.startDate === null ||
                                        values.startDate === '') &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    minDate={dayjs(values.startDate)}
                                    maxDate={dayjs()}
                                    className="bg__white"
                                    labelid="IFSP.endDate"
                                    disableFuture={false}
                                    defaultlabelid="End Date"
                                    value={
                                      values.endDate
                                        ? dayjs(values.endDate)
                                        : null
                                    }
                                    handlechange={(dateValue: Dayjs | null) => {
                                      const formattedDate =
                                        dayjs(dateValue).format('MM/DD/YYYY');
                                      if (dateValue === null) {
                                        setFieldValue('endDate', null);
                                      } else {
                                        setFieldValue('endDate', formattedDate);
                                      }
                                    }}
                                  />
                                  {errors.endDate && touched.endDate && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.endDate}
                                      defaultlabel="End Date is Required"
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={5}>
                                  <DropdownComponent
                                    disabled={
                                      (isIfspScreenLocked &&
                                        !canEditAfterLock) ||
                                      !hasEditPermission
                                    }
                                    labelid="IFSP.reasonForLate"
                                    defaultlabelid="Reason for Late"
                                    names={fliteredLookUpReasons}
                                    value={values.reasonIfLate}
                                    handleChange={(value: string) => {
                                      setFieldValue('reasonIfLate', value);
                                    }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  className="flex__ pl-md mt-xs po cursorPointer"
                                  onClick={() => {
                                    if (
                                      !isIfspScreenLocked ||
                                      (canEditAfterLock && isEdit)
                                    ) {
                                      setOpenedSubSectionIndex(subSectionIndex);
                                      handleSubmit();
                                    }
                                  }}
                                >
                                  <AddNew />
                                  <MediumTypography
                                    className="ml-xs"
                                    labelid={servicePlanLabelId}
                                    defaultlabel={servicePlanDefaultLabel}
                                  />
                                </Grid>
                              </Grid>

                              <Box
                                component="div"
                                className="respoScrollTable mt-lg mb-md"
                                sx={{
                                  opacity: hasEditPermission ? 'unset' : '0.8',
                                }}
                              >
                                <TableContainer component={Paper}>
                                  <Table>
                                    <TableHeader
                                      className="listDataTableHead"
                                      headerNames={headCells}
                                      checkBoxRequired={false}
                                      order={order}
                                      orderBy={orderBy}
                                      onRequestSort={handleRequestSort}
                                    />
                                    <TableBody className="tableRowcss">
                                      {openIndex === subSectionIndex &&
                                        sdpMainData[
                                          subSectionIndex
                                        ].earlyInterventionService.map(
                                          (
                                            listData: ServiceDeliveryPlanPropsData,
                                            index,
                                          ) => (
                                            <EIServiceTableRow
                                              hasEditPermission={
                                                hasEditPermission
                                              }
                                              isIfspScreenLocked={
                                                isIfspScreenLocked
                                              }
                                              canEditAfterLock={
                                                canEditAfterLock
                                              }
                                              canDeleteAfterLock={
                                                canDeleteAfterLock
                                              }
                                              actionMode={
                                                isEdit ? 'update' : 'add'
                                              }
                                              key={`eiServiceTableRow${
                                                index + 1
                                              }`}
                                              dataLength={
                                                sdpMainData[subSectionIndex]
                                                  .earlyInterventionService
                                                  .length
                                              }
                                              actionRequired={true}
                                              data={listData}
                                              onEdit={() => {
                                                if (
                                                  !isIfspScreenLocked ||
                                                  canEditAfterLock
                                                ) {
                                                  onEditRow(
                                                    subSectionIndex,
                                                    index,
                                                  );
                                                }
                                              }}
                                              onDelete={() => {
                                                if (
                                                  (!isIfspScreenLocked &&
                                                    values.tbrServicePlanId <
                                                      1) ||
                                                  (canDeleteAfterLock &&
                                                    sdpMainData[subSectionIndex]
                                                      .earlyInterventionService
                                                      .length > 1)
                                                ) {
                                                  onDeleteRow(
                                                    subSectionIndex,
                                                    index,
                                                  );
                                                }
                                              }}
                                              reasonIfLate={lookUpReasons}
                                              eiService={eiService}
                                              intensity={intensity}
                                              locationOfService={
                                                locationOfService
                                              }
                                              period={period}
                                              providedBy={providedBy}
                                            />
                                          ),
                                        )}
                                    </TableBody>
                                  </Table>
                                  {sdpMainData[subSectionIndex]
                                    .earlyInterventionService.length === 0 && (
                                    <Box component="div" className="width__100">
                                      <MediumTypography
                                        textstyle={'center'}
                                        labelid="IFSP.emptyMessage"
                                        defaultlabel="No data added yet"
                                        className="p-sm"
                                      />
                                    </Box>
                                  )}
                                </TableContainer>
                              </Box>
                              <Box
                                component="div"
                                className="pt-md"
                                sx={{
                                  pointerEvents: hasEditPermission
                                    ? 'auto'
                                    : 'none',
                                  opacity: hasEditPermission ? 1 : 0.8,
                                }}
                              >
                                {ServiceDeliveryPlanData.EIService.map(
                                  (question) => (
                                    <Box component="div" key={question.id}>
                                      <Box
                                        component="div"
                                        className="align__items__center display-inline-flex"
                                      >
                                        <MediumTypography
                                          sxProps={{
                                            marginLeft: '4px',
                                            marginRight: '24px',
                                          }}
                                          labelid={question.displayQueId}
                                          defaultlabel={question.displayQuetext}
                                        />
                                      </Box>
                                      <Box
                                        component="div"
                                        className="pt-sm"
                                        sx={{ width: '48%' }}
                                      >
                                        <CommentTextbox
                                          name={'justification'}
                                          className="translate"
                                          disabled={
                                            isIfspScreenLocked &&
                                            !canEditAfterLock
                                          }
                                          placeholder="Enter your comments"
                                          Value={
                                            question.key === 'justification'
                                              ? sdpMainData[subSectionIndex]
                                                  .justification
                                              : ''
                                          }
                                          handlechange={(value) =>
                                            setSdpMainData((prevData) => {
                                              const tempData = [...prevData];
                                              if (
                                                question.key === 'justification'
                                              ) {
                                                tempData[
                                                  subSectionIndex
                                                ].justification = value;
                                              }
                                              return tempData;
                                            })
                                          }
                                          rows={5}
                                          style={TextAreaStyle}
                                          maxLength={5000}
                                        />
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                              <Box
                                component="div"
                                className="mb-lg pb-lg"
                                sx={{
                                  borderBottom: '1px solid #00C6B8',
                                  pointerEvents: hasEditPermission
                                    ? 'auto'
                                    : 'none',
                                  opacity: hasEditPermission ? 1 : 0.8,
                                }}
                              >
                                <MediumTypography
                                  defaultlabel="Other Services"
                                  labelid="IFSP.otherServices"
                                  sxProps={{
                                    marginTop: '16px',
                                    marginBottom: '8px',
                                  }}
                                  fontSize="16px"
                                  fontweight={600}
                                />
                                {ServiceDeliveryPlanData.OtherServices.map(
                                  (question) => (
                                    <Box component="div" key={question.id}>
                                      <Box
                                        component="div"
                                        className="align__items__center display-inline-flex"
                                      >
                                        <MediumTypography
                                          sxProps={{
                                            marginLeft: '4px',
                                            marginRight: '24px',
                                            fontFamily: 'Lato-Regular',
                                            fontSize: 14,
                                            fontWeight: 500,
                                          }}
                                          labelid={question.displayQueId}
                                          defaultlabel={question.displayQuetext}
                                        />
                                      </Box>
                                      <Box
                                        component="div"
                                        className="pt-sm"
                                        sx={{ width: '48%' }}
                                      >
                                        <CommentTextbox
                                          className="translate"
                                          name={
                                            question.key ===
                                            'otherNeededService'
                                              ? 'otherNeededService'
                                              : 'stepsToTake'
                                          }
                                          placeholder="Enter your comments"
                                          disabled={
                                            isIfspScreenLocked &&
                                            !canEditAfterLock
                                          }
                                          Value={
                                            question.key ===
                                            'otherNeededService'
                                              ? sdpMainData[subSectionIndex]
                                                  .otherNeededService
                                              : sdpMainData[subSectionIndex]
                                                  .stepsToTake
                                          }
                                          handlechange={(value) =>
                                            setSdpMainData((prevData) => {
                                              const tempData = [...prevData];
                                              if (
                                                question.key ===
                                                'otherNeededService'
                                              ) {
                                                tempData[
                                                  subSectionIndex
                                                ].otherNeededService = value;
                                              }
                                              if (
                                                question.key === 'stepsToTake'
                                              ) {
                                                tempData[
                                                  subSectionIndex
                                                ].stepsToTake = value;
                                              }
                                              return tempData;
                                            })
                                          }
                                          rows={5}
                                          maxLength={5000}
                                          style={TextAreaStyle}
                                        />
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      ))}
                      {hasEditPermission && (
                        <Box>
                          <ButtonComponent
                            disabled={
                              sdpMainData.length >= 2 || isIfspScreenLocked
                            }
                            className="btn-primary btn-submit"
                            variantType="contained"
                            type="submit"
                            labelId="Ifsp.sdpButton"
                            defaultLabelId="Add EIBI SSP Services"
                            onClick={() => {
                              addSubSection();
                            }}
                          />
                          <MediumTypography
                            labelid="Ifsp.sdpHelpText"
                            defaultlabel="Add Additional Service Delivery Plan for EIBI SSP Service (Autism, Down Syndrome)"
                            fontSize="12px"
                            fontweight={400}
                            textColor="#2A4241"
                            fontStyle="italic"
                          />
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </Formik>
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceDeliveryPlan;
